import React from 'react';
import {FeesBreakdown} from '../../components/FeesBreakdown/FeesBreakdown';
import ErrorBoundary from '../../components/ErrorBoundary/ErrorBoundary';
import {SummarySection} from './SummarySection';

/**
 * BAU Fees Breakdown summary section. Extracted so it can be rendered both for
 * non-dentist users directly and additionally (via a toggle) inside the dentist
 * BuilderFeeCalculator for comparison.
 */
export const FeesBreakdownSection: React.FC = () => {
  return (
    <SummarySection
      editable={false} // this is handled by the BE for this component
      step="tasks" // same as above
      title="Fees Breakdown"
      test="bau-fees"
    >
      <ErrorBoundary inline>
        <FeesBreakdown />
      </ErrorBoundary>
    </SummarySection>
  );
};
